import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { InmateNote } from '@reliance/types/models/InmateNote';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

type InmateNoteFilters = PaginationFilters & {
  inmateId?: number;
};

export const useInmateNotesByInmateId = (
  inmateId: number | null | undefined,
  filters?: InmateNoteFilters
) => {
  return useAsync<IPaginatedResponse<InmateNote>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: InmateNoteFilters = {
        inmateId: id,
        ...filters,
      };

      return api
        .get<IPaginatedResponse<InmateNote>>('/inmate-note', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, filters]
  );
};
